import { useTranslation } from "react-i18next";
import useStaff from "../hooks/useStaff";
import { useEffect, useMemo, useState } from "react";
import PageHeader from "components/Common/PageHeader";
import { all_routes } from "router/all_routes";
import CustomButton from "components/Common/ui/CustomButton";
import TableFilterDynamique, { FilterField } from "components/Common/TableFilter/TableFilterDynamique";
import { CONTRACT_TYPE_OPTIONS } from "constants/staffConstants";
import StaffTable from "../components/staffTable";
import { useAbility } from "config/abilityContext";


const StaffPage = () => {
    const { t } = useTranslation();
    const { staffs, loading, error, fetchStaffs, pagination, handleDelete } = useStaff();
    const [filters, setFilters] = useState<{ [key: string]: string | number | null }>({});
    const ability = useAbility();
    const breadcrumbItems = [
        { label: "dashboard", path: all_routes.dashboard },
        { label: "staff.title", active: true },
    ];


    const filterFields: FilterField[] = useMemo(
        () => [{ key: "search", label: t("search"), type: "text" },
        { key: "typeContract", label: t("staff.form.contractType"), type: "select", options: CONTRACT_TYPE_OPTIONS },],
        [t]
    );

    const handleFilter = (newFilters: { [key: string]: string | number | null }) => {
        setFilters(newFilters);
        fetchStaffs({
            ...newFilters,
            page: 1,
            limit: 10,
            includeUser: true,
        });
    };
    useEffect(() => {
        fetchStaffs({ page: 1, limit: 10, includeUser: true });
    }, []);

    return (
        <div className="page-wrapper">
            <div className="content container-fluid">
                <PageHeader title={t("staff.title")} breadcrumbItems={breadcrumbItems} />

                <div className="d-flex mb-3 justify-content-end gap-2">
                    {ability.can("create", "Staff") && (
                        <CustomButton asLink to={all_routes.staffCreate}>
                            <i className="fa fa-plus me-2"></i>
                            {t("staff.add_staff")}
                        </CustomButton>
                    )}

                    <TableFilterDynamique
                        fields={filterFields}
                        filters={filters}
                        onApply={(newFilters) => handleFilter(newFilters)}
                        onReset={() => handleFilter({ page: 1, limit: 10 })}
                    />
                </div>

                <StaffTable
                    dataSource={staffs}
                    loading={loading}
                    dataPaginate={{
                        current: pagination.page,
                        pageSize: pagination.limit,
                        total: pagination.total,
                    }}
                    onDelete={(id) => handleDelete(id)}
                    onChange={(pg) => {
                        fetchStaffs({
                            ...filters,
                            page: pg.current!,
                            limit: pg.pageSize!,
                        });
                    }}
                />
            </div>
        </div>
    )


}

export default StaffPage

